import React from 'react';
import { Box, Typography } from '@mui/material';
import VerificationFailureNotice from '../VerificationFailureNotice';
import { useTranslation } from 'react-i18next';

function FailuresSection({ failures, onDismiss }) {
  const { t } = useTranslation('shared');
  if (!failures || failures.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" color="warning.main" fontWeight="bold" mb={1.5}>
        {t('failuresSection.notices', { count: failures.length })}
      </Typography>
      {failures.map((failure) => (
        <VerificationFailureNotice
          key={failure.failure_id}
          failure={failure}
          onDismiss={onDismiss}
        />
      ))}
    </Box>
  );
}

export default FailuresSection;
